import { Tooltip } from "@mui/material";
import { Badge, Button } from "$components";
import { theme } from "$utils/theme/bataillog";
import { EdbStatus } from "$types/EDB";
import { getEdbStatusColor, getEdbStatusLabel } from "$utils/typeConstants";

type Props = {
  isDisabled?: boolean;
  status: EdbStatus;
  approverName?: string;
};

function EdbStatusBadge({ isDisabled = false, status, approverName }: Props) {
  const waitingTooltip = approverName
    ? `En attente de validation par ${approverName}`
    : "En attente de validation — aucun approbateur désigné sur ce chantier";

  const isCartCreated = status === EdbStatus.CART_CREATED;

  const badge = (
    <div style={{ whiteSpace: "nowrap", margin: "4px 0" }}>
      {isCartCreated ? (
        <Button
          color="secondary"
          onClick={() => {}}
          style={{
            padding: "7px",
            fontSize: 13,
            minWidth: 130,
            display: "block",
            lineHeight: "15px",
          }}
        >
          {getEdbStatusLabel(status, true)}
        </Button>
      ) : (
        <Badge colorManual={getEdbStatusColor(status, theme, isDisabled)}>
          <span
            style={{
              width: 124,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "inline-block",
              overflow: "hidden",
              fontFamily: "Roboto",
              fontSize: 13,
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            {getEdbStatusLabel(status)}
          </span>
        </Badge>
      )}
    </div>
  );

  if (status === EdbStatus.WAITING) {
    return (
      <Tooltip title={waitingTooltip} placement="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
}

export default EdbStatusBadge;
